import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

export const RestaurantChangeDialog = ({ open, onOpenChange, restaurantName, onConfirm, onCancel }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent
      className="rounded-3xl border-brand-brown/10 bg-brand-cream"
      onEscapeKeyDown={(event) => event.preventDefault()}
      onPointerDownOutside={(event) => event.preventDefault()}
    >
      <AlertDialogHeader>
        <AlertDialogTitle className="font-serif text-2xl text-brand-ink">Change restaurant?</AlertDialogTitle>
        <AlertDialogDescription className="leading-relaxed text-brand-mute">
          Your cart belongs to {restaurantName || "another restaurant"}. Changing restaurants will clear every item in it.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel} data-testid="restaurant-switch-cancel">Keep my cart</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          data-testid="restaurant-switch-confirm"
          className="bg-brand-red text-brand-cream hover:bg-brand-burgundy"
        >
          Clear cart and change
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

